import merchantActions from "./merchantActions";

const allMerchantActions = {
  merchantActions,
};

export default allMerchantActions;
